import React from 'react';
import { User, Search, CheckCircle, ChevronRight } from 'lucide-react';
import './HowItWorks.css';

const steps = [
  {
    number: '01',
    icon: <User size={32} color="#B8FF3C" />,
    title: 'Create Your Profile',
    description: 'Sign up, add your profile details, set a self-rating, and choose location settings that fit how you play.',
  },
  {
    number: '02',
    icon: <Search size={32} color="#0088FF" />,
    title: 'Find Courts & Friends',
    description: 'Search courts by city or zip, filter court results, add friends, and organize your local pickleball network.',
  },
  {
    number: '03',
    icon: <CheckCircle size={32} color="#FF9900" />,
    title: 'Check In & Plan Sessions',
    description: 'Check in with a play duration, join friends who are already at a court, and create scheduled sessions with RSVPs.',
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section className="how-it-works" id="how-it-works">
      <div className="how-it-works__container">
        <div className="section-header">
          <div className="section-badge">How It Works</div>
          <h2>Get started in<br /><span className="text-gradient">3 simple steps</span></h2>
        </div>

        <div className="steps">
          {steps.map((step, i) => (
            <React.Fragment key={i}>
              <div className="step">
                <div className="step__number">{step.number}</div>
                <div className="step__content">
                  <div className="step__icon">{step.icon}</div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
              {i < steps.length - 1 && (
                <div className="step__connector">
                  <ChevronRight size={32} color="#D1D5DB" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
